import $ from "jquery";
function add_choice(e) {
  var target = e.dataset.target;
  var optionlist = $(e.dataset.optionlist);
  var type = e.dataset.type;
  var name = e.dataset.name;
  var optioncount = optionlist.children().length;

  var c = e.value.trim().replace('"', "&#34;").replace("'", "&#39;");
  if (c.length === 0) {
    return;
  }

  //
  // Check to see if this choice already exists. If so just select it.
  //
  if (optionlist.find("input[value='" + c + "']").length) {
    var existing = $(target)
      .siblings()
      .find("input[value='" + c + "']");
    existing.prop("checked", true).change();
    if (type === "radio") {
      $(target).siblings("label").removeClass("active");
    }
    existing.parent().addClass("active");
  } else {
    //
    // Set the label's text with the text() method so that it will be escaped.
    // Otherwise we could have an XSS security issue.
    //
    if (type === "radio") {
      $(target).before(
        $("<label class='btn btn-tag text-break-words'></label>")
          .text(c)
          .append(
            "<input type='" +
              type +
              "' name=" +
              name +
              " value='" +
              c +
              "' autocomplete=off/>",
          ),
      );
    } else {
      $(target).before(
        $("<label class='btn btn-tag text-break-words active'></label>")
          .text(c)
          .append(
            "<input type='" +
              type +
              "' name=" +
              name +
              " value='" +
              c +
              "' autocomplete=off checked/>",
          ),
      );
    }

    optionlist.append(
      '<input name="' +
        optionlist.data("namefor") +
        "[" +
        optioncount +
        ']" type="hidden" value="' +
        c +
        '">',
    );
  }

  e.value = "";
}

$(document).on("keydown", "input.newchoice", function (event) {
  if (event.key === "Enter" || event.key === "|") {
    add_choice(event.target);
    return false;
  }
  return true;
});

$(document).on("change", "input.newchoice", function (event) {
  add_choice(event.target);
  return true;
});

$(document).on(
  "click",
  ".multiplechoicecomponent label.toggle",
  function (event) {
    var input = $(event.target)
      .closest(".multiplechoicecomponent")
      .find("input.newchoice");
    input.toggle();
    input.focus();
    return true;
  },
);

//
// We want non-standard behavior where if you
// click on a selected single-choice tag, it will deselect it
// leaving no entry at all.
//
$(document).on(
  "click",
  ".multiplechoicecomponent label.singlechoice.active.btn",
  function (event) {
    event.target.classList.remove("active");
    event.target.children[0].checked = false;
    return false;
  },
);
